<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/purchase/invoices">{{ $t('purchase_invoice') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('convert_from_stockin') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"/> {{ $t('back') }}</button>
            <b-btn v-if="isComplete" variant="outline-primary no-bor" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group" :class="{ 'form-group-error': $v.invoice.VendorId.$error }">
                                <label class="label-control blue">{{ $t('vendor') }}</label>
                                <div>
                                    <VendorSelector @select="vendorSelected" :value="invoice.VendorName" place="Choose a vendor" :disabled="isUpdate"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9" v-if="invoice.VendorId!=''">
                            <div class="form-group">
                                <label class="control-label blue">&nbsp;</label>
                                <div>
                                    <button v-if="!isComplete" type="button" class="btn btn-success btn-sm" @click="onGenerate"><i class="fa fa-plus-circle" aria-hidden="true"></i> {{$t('create_invoice')}}</button>
                                    <button v-else type="button" class="btn btn-danger btn-sm" @click="onCancel"><i class="fa fa-times" aria-hidden="true"></i> {{$t('cancel')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.invoice.Contact.$error }">
                                <label class="label-control blue">{{$t('contact')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="$v.invoice.Contact.$model" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label blue">{{$t('date')}}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.Date" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="control-label blue">{{$t('due_date')}}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.DueDate" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('ref_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="invoice.RefNum" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isComplete">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table table-bordered table-sm no-bor">
                                    <thead>
                                        <tr>
                                            <th style="width:30px; vertical-align: middle;">{{$t('no')}}</th>
                                            <th>{{$t('item_code')}}</th>
                                            <th>{{$t('item_name')}}</th>
                                            <th>{{$t('description')}}</th>
                                            <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                            <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                            <th class="text-right" style="width: 100px;">{{$t('cost')}}</th>
                                            <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                            <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(ret,index) in lines" :key="index">
                                            <td class="text-center">{{index+1}}</td>
                                            <td>{{ret.ItemCode}}</td>
                                            <td>{{ret.ItemName}}</td>
                                            <td class="cell-input"><input type="text" class="form-control form-control-sm" v-model="ret.Description"></td>
                                            <td class="text-center">{{ret.Quantity}}</td>
                                            <td class="text-center">{{ret.UomName}}</td>
                                            <td class="cell-input">
                                                <input type="text"
                                                    class="form-control form-control-sm text-right"
                                                    v-model="ret.Price"
                                                    v-decimal-only
                                                    @blur="calculate">
                                            </td>
                                            <td class="cell-input">
                                                <input type="text"
                                                    class="form-control form-control-sm text-right"
                                                    v-model="ret.TaxLine"
                                                    v-decimal-only
                                                    @blur="calculate">
                                            </td>
                                            <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                        </tr>
                                        <tr>
                                            <th colspan="8" class="text-right">{{$t('total')}}:</th>
                                            <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="8" class="none-left text-right">{{$t('taxes')}}:</th>
                                            <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="8" class="text-right">{{$t('grand_total')}}:</th>
                                            <th class="text-right">{{$money(invoice.PaidAmount)}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 30px;"><input type="checkbox" v-model="isCheck"></th>
                                    <th>{{$t('stockin_no')}}</th>
                                    <th>{{$t('date')}}</th>
                                    <th>{{$t('description')}}</th>
                                    <th>{{$t('branch_name')}}</th>
                                    <th>{{$t('receiver')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in stockins" :key="index">
                                    <td class="text-center"><input type="checkbox" v-model="ret.Checked"></td>
                                    <td>{{ret.Num}}</td>
                                    <td>{{$format(ret.InDateAt,'DD/MM/YYYY')}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td>{{ret.BranchName}}</td>
                                    <td>{{ret.EmployeeName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {required} from 'vuelidate/lib/validators';
import { Stock, Purchase } from '../../shared/models/model';
import { VendorSelector } from '../Vendors';
export default {
    components: {
        VendorSelector
    },
    data(){
        return {
            invoice: {
                VendorId: '',
                Date: this.$now().format('YYYY-MM-DD'),
                DueDate: this.$now().format('YYYY-MM-DD'),
                DocSource: 'Delivery'
            },
            lines: [],
            stockins: [],
            isComplete: false,
            isCheck: false,
            links: [],
            isUpdate: false
        }
    },
    validations:{
        invoice: {
            VendorId: { required },
            Contact: { required },
        }
    },
    created(){
        let id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.isComplete = true;
            this.isUpdate = true;
            this.findById(id);
        }
    },
    methods: {
        findById(id){
            let loading = this.$loading.show();
                this.$api().post('po/invoice/find', { Id: id }).then(res => {
                var data = res.data.Data;
                this.invoice = data.POInvoice;
                this.lines = data.POInvoiceLines;
                this.invoice.Date = this.$format(this.invoice.Date, 'YYYY-MM-DD');
                this.invoice.DueDate = this.$format(this.invoice.DueDate, 'YYYY-MM-DD');
                this.reCalculate();
            }).finally(function() { loading.hide(); });
        },
        onSave(){
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.invoice.CompanyId = this.$store.state.company.Id;
                this.invoice.ClientId = this.$store.state.company.ClientId;
                let loading = this.$loading.show();
                let req = {
                    Header: this.invoice,
                    Lines: this.lines,
                    Links: this.links 
                };
                Purchase.saveInvoice(req, this.isUpdate).then(() => {
                    this.$router.go(-1);
                }).finally(() => { loading.hide(); });
            }
        },
        vendorSelected(e){
            this.isComplete = false;
            this.invoice.VendorId = e.data.Id;
            this.invoice.Contact = e.data.Phone;
            this.getStockin();
        },
        onGenerate(){
            let links = [];
            let desc = [];
            let checkeds = this.stockins.filter(el => el.Checked == true);
            if(checkeds.length > 0){
                let loading = this.$loading.show();
                let ids = [];
                checkeds.forEach(el => {
                    ids.push(el.Id);
                    links.push({ StockinId: el.Id });
                    desc.push(el.Num + ':' + this.$format(el.InDateAt,'DD/MM/YYYY'));
                });
                this.links = links;
                Stock.getInvoiceLineByStockin({ Ids: ids }).then(res => {
                    this.lines = res.Json.Lines;
                    this.calculate();
                    this.isComplete = true;
                }).finally(() => { loading.hide(); });
            }else{
                this.$swal.fire('Warning Message', 'Please select at least one records.', 'warning');
            }
        },
        onCancel(){
            this.isComplete = false;
            if(this.isUpdate)
                this.getStockin();
        },
        calculate(){
            let total = 0;
            let taxes = 0;
            this.lines.forEach(el => {
                let subTotal = Number(el.Quantity) * Number(el.Price);
                el.SubTotal = subTotal;
                total += subTotal;
                taxes += subTotal * Number(el.TaxLine) / 100;
            });
            this.invoice.TaxVat = taxes;
            this.invoice.GrandTotal = total;
            this.invoice.PaidAmount = total + taxes;
        },
        getStockin(){
            let loading = this.$loading.show();
            Stock.getStockinFromVendor({ Id: this.invoice.VendorId }).then(res => {
                this.stockins = res.Json.Stockins;
            }).finally(() => { loading.hide(); });
        }
    },
    watch: {
        isCheck(value){
            this.stockins.forEach(el=>{
                el.Checked = value;
            });
        }
    }
}
</script>